import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

function Bredcom() {
  const { t } = useTranslation();
  const location = useLocation();

  // Dobijamo ime trenutne stranice iz putanje
  const pageName = location.pathname.split("/").pop();
  const subtitleKey = `pages.${pageName}`;

  return (
    <>
      <section
        className="breadcrumb-area d-flex p-relative align-items-center"
        style={{ backgroundImage: "url(/assets/img/bg/BredcomBanner.png)" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-left">
                <div className="breadcrumb-title">
                  <h2> {t(subtitleKey)} </h2>
                </div>
              </div>
            </div>
            <div className="breadcrumb-wrap2">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/"> {t("breadcrumb.home")} </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t(subtitleKey)}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Bredcom;
